/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
let n;function t(){return n}function e(t){n=t}export{t as getAccessorInterceptor,e as setAccessorInterceptor};
